import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import { defineComponent as _defineComponent } from 'vue';
import { useQueryLoading } from '@vue/apollo-composable';
import { useGetAccountQuery, useListGroupNamesInPortfolioQuery } from '~/types/types';
import { getLocale } from '~/functions/translate';
export default /*#__PURE__*/_defineComponent({
  __name: 'GroupNames',
  emits: ["update:value"],
  setup: function setup(__props) {
    var _useGetAccountQuery = useGetAccountQuery(),
      accountResult = _useGetAccountQuery.result;
    var account = computed(function () {
      var _accountResult$value;
      return (_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : _accountResult$value.getAccount;
    });
    var _useListGroupNamesInP = useListGroupNamesInPortfolioQuery(computed(function () {
        var _account$value;
        return {
          portfolioId: (_account$value = account.value) === null || _account$value === void 0 ? void 0 : _account$value.id
        };
      }), computed(function () {
        return {
          enabled: !!account.value,
          fetchPolicy: 'cache-and-network'
        };
      })),
      groupNamesResult = _useListGroupNamesInP.result;
    var groupNames = computed(function () {
      var _groupNamesResult$val;
      var apiGroups = ((_groupNamesResult$val = groupNamesResult.value) === null || _groupNamesResult$val === void 0 ? void 0 : _groupNamesResult$val.listGroupNamesInPortfolio) || [];
      var locale = getLocale();
      return [locale === 'en' ? 'All companies' : 'Alle Unternehmen'].concat(_toConsumableArray(apiGroups), [locale === 'en' ? 'No Group' : 'Keine Gruppe']);
    });
    var loading = useQueryLoading();
    return {
      __sfc: true,
      accountResult: accountResult,
      account: account,
      groupNamesResult: groupNamesResult,
      groupNames: groupNames,
      loading: loading
    };
  }
});